import { Controller } from '@hotwired/stimulus';

export class EventController extends Controller {
  prevent(event) {
    event.preventDefault();
  }

  stop(event) {
    event.stopPropagation();
  }

  stopImmediate(event) {
    event.stopImmediatePropagation();
  }
}
